import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import OrderFilter from '../models/Orders/OrderFilter';

@Module({ namespaced: true, name: 'FilterManagerModule' })
export default class FilterManagerModule extends VuexModule {

    public savedFilters: OrderFilter = new OrderFilter;

    @Mutation
    SET_FILTER(filter: OrderFilter) {
        this.savedFilters = filter;
    }

    @Mutation
    RESET_FILTER() {
        this.savedFilters = new OrderFilter;
    }

    @Action({ commit: 'SET_FILTER', rawError: true })
    setFilter(filter: OrderFilter): OrderFilter {
        return filter;
    }

    @Action({ commit: "RESET_FILTER", rawError: true })
    resetFilter() {

    }

    public get orderFilter() {
        return this.savedFilters;
    }

}